import {  h } from "preact"
import { StyledContainer } from "./styled"

interface IContainer {
    children?: JSX.Element|JSX.Element[]|React.ReactNode;
}

const Container = ({ children }: IContainer) => {
    return <StyledContainer>
        {children}
    </StyledContainer>
}

export default Container;